export default (theme: any) => ({
    root: {
        flexGrow: 1,
    },

    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        borderRadius: '2px',
    },

    buttonActived: {
        marginLeft: '25%',
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
        },
    },

    buttonNotActived: {
        marginLeft: '25%',
        color: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.main,
        },
    },

    datatableCardContent: {},

    cardHeaderTitle: {
        [theme.breakpoints.up('sm')]: {
            paddingLeft: '50px',
        },
    },

    actionButton: {
        minWidth: '100%',
        borderRadius: '2px',
    },

    pagination: {
        paddingBottom: '10px',
    },

    paginationUl: {
        flexWrap: 'nowrap',
    },

    firstRow: {
        paddingBottom: '25px',
    },

    searchField: {
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            marginLeft: '20px',
            width: '80%',
        },
    },

    searchIcon: {
        maxWidth: '28px',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '10px',
        },
    },

    gridItemContent: {
        marginTop: '5px',
        marginBottom: '10px',
        marginLeft: '5px',
        marginRight: '5px',
        width: '100%',
    },

    menuButton: {
        padding: '15px 20px',
        borderBottom: 'solid 2px',
        borderBottomColor: theme.palette.lightGrey.main,
        margin: '0px 30px',
    },

    menu: {
        padding: '20px',
    },

    resetButtonContainer: {
        padding: '15px 20px',
        margin: '0px 30px',
    },

    resetButtonActived: {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
        },
    },
})
